/** snake_case is the wire format, not a label. */
export const AGENCY_ZOOM_MARITAL_STATUS_VALUES = [
  "single",
  "married",
  "widowed",
  "separated",
  "divorced",
  "domestic_partner",
  "civil_union",
  "fiance",
  "unknown",
  "other",
] as const;

export const AGENCY_ZOOM_MARITAL_STATUS_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_MARITAL_STATUS_VALUES)[number],
  string
> = {
  single: "agencyZoomCreateLeadSettings.maritalStatus.single",
  married: "agencyZoomCreateLeadSettings.maritalStatus.married",
  widowed: "agencyZoomCreateLeadSettings.maritalStatus.widowed",
  separated: "agencyZoomCreateLeadSettings.maritalStatus.separated",
  divorced: "agencyZoomCreateLeadSettings.maritalStatus.divorced",
  domestic_partner: "agencyZoomCreateLeadSettings.maritalStatus.domesticPartner",
  civil_union: "agencyZoomCreateLeadSettings.maritalStatus.civilUnion",
  fiance: "agencyZoomCreateLeadSettings.maritalStatus.fiance",
  unknown: "agencyZoomCreateLeadSettings.maritalStatus.unknown",
  other: "agencyZoomCreateLeadSettings.maritalStatus.other",
};
